// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const treeClasses = {
  branch: "qui-tree__branch-root",
  branchContent: "qui-tree__branch-content",
  branchIndentGuide: "qui-tree__branch-indent-guide",
  branchTrigger: "qui-tree__branch-trigger",
  label: "qui-tree__label",
  nodeAction: "qui-tree__node-action",
  nodeIcon: "qui-tree__node-icon",
  nodeIndicator: "qui-tree__node-indicator",
  nodeRoot: "qui-tree__node-root",
  root: "qui-tree__root",
} as const
